"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var getStyleParamsWithDefaults_1 = require("./getStyleParamsWithDefaults");
exports.withDefaultStyleParams = function (WrappedComponent, getDefaultStyleParamsFunc) {
    return function (props) {
        var style = props.host.style;
        var styleWithDefaultStyleParams = tslib_1.__assign(tslib_1.__assign({}, style), { styleParams: getStyleParamsWithDefaults_1.getStyleParamsWithDefaults(style.styleParams, function () { return getDefaultStyleParamsFunc(props); }) });
        var host = tslib_1.__assign(tslib_1.__assign({}, props.host), { style: tslib_1.__assign({}, styleWithDefaultStyleParams) });
        return React.createElement(WrappedComponent, tslib_1.__assign({}, props, { style: styleWithDefaultStyleParams, host: host }));
    };
};
//# sourceMappingURL=withDefaultStyleParams.js.map